__turbopack_context__.v({
  "product-media": "product-media-component-module-scss-module__exxw8q__product-media",
  "product-media__image-section": "product-media-component-module-scss-module__exxw8q__product-media__image-section",
  "product-media__tile": "product-media-component-module-scss-module__exxw8q__product-media__tile",
  "product-media__tile--selected": "product-media-component-module-scss-module__exxw8q__product-media__tile--selected",
  "product-media__video-section": "product-media-component-module-scss-module__exxw8q__product-media__video-section",
});
